import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://agmconsulting.hu';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1760246964044-1384f71665b9?w=1200&h=630&fit=crop&crop=entropy&cs=srgb&fm=jpg&q=85';
const SITE_NAME = 'AGM Consulting';

function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(url) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

export default function SEO({ title, description, image, path }) {
  const location = useLocation();
  const currentPath = path || location.pathname;
  const fullUrl = `${BASE_URL}${currentPath}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Professzionális könyvelés és adótanácsadás`;
  const desc = description || 'Digitális működés, szakértői háttér, teljes átláthatóság. Fókuszáljon a saját vállalkozására, a könyveléssel mi foglalkozunk.';
  const img = image || DEFAULT_IMAGE;

  useEffect(() => {
    document.title = fullTitle;

    // Standard
    setMeta('description', desc);

    // Open Graph
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', desc, true);
    setMeta('og:image', img, true);
    setMeta('og:url', fullUrl, true);
    setMeta('og:type', 'website', true);
    setMeta('og:site_name', SITE_NAME, true);
    setMeta('og:locale', 'hu_HU', true);

    // Twitter / X
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);
    setMeta('twitter:image', img);

    // Canonical
    setCanonical(fullUrl);
  }, [fullTitle, desc, img, fullUrl]);

  return null;
}
